import React from 'react';
import Can from "../Can";
import LabStatsPage from './LabStatsPage';

function LabStats(props) {
    var myHome;

    if (!props.apiAuthGroups) {
        myHome = (
            <React.Fragment>
                <h2>Non autorizzato</h2>
            </React.Fragment>
        )
    } else {
        myHome = (
            <Can
                role={props.apiAuthGroups}
                perform="labConsolle-page:visit"
                yes={() => (
                    <LabStatsPage />
                )}
                no={() => null}
            />
        )
    }

    return myHome;
}

export default LabStats;
